import { currentOrderedProductLevels } from 'self-service-api/constants/ProductLevels';
import { useAppSelector } from '../reducers';
import { productsFromProductInventorySelector } from '../selectors/ProductInventorySelectors';
import { skuIdHasBundledProductsSelector } from '../selectors/ProductsSelectors';
const productLinePriority = ['OPERATIONS', 'SERVICE', 'SALES', 'MARKETING', 'CMS'];
export const useSortedProductInventory = () => {
  const productInventory = useAppSelector(productsFromProductInventorySelector);
  const sortedProductInventory = useAppSelector(state => {
    return productInventory.sort((a, b) => {
      // if not in currentOrderedProductLevels, put it at the end
      if (a.productLevel === 'BASIC' || !currentOrderedProductLevels.includes(a.productLevel)) {
        return 1;
      }
      if (b.productLevel === 'BASIC' || !currentOrderedProductLevels.includes(b.productLevel)) {
        return -1;
      }

      // If multiple products have the same product level, sort by bundled products / product line priority
      if (a.productLevel === b.productLevel) {
        // bundled products have higher priority
        if (skuIdHasBundledProductsSelector(state, {
          skuId: a.currentVersion.skuId
        })) {
          return -1;
        }
        if (skuIdHasBundledProductsSelector(state, {
          skuId: b.currentVersion.skuId
        })) {
          return 1;
        }
        return productLinePriority.indexOf(a.productLine) - productLinePriority.indexOf(b.productLine);
      }

      // sort by product level priority, Ent being the highest priority
      return currentOrderedProductLevels.indexOf(b.productLevel) - currentOrderedProductLevels.indexOf(a.productLevel);
    });
  });
  return sortedProductInventory;
};